import { render, staticRenderFns } from "./Mailbox.vue?vue&type=template&id=054d02c9&scoped=true"
import script from "./Mailbox.vue?vue&type=script&lang=js"
export * from "./Mailbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054d02c9",
  null
  
)

export default component.exports